import {
    Directive,
    DoCheck,
    ElementRef,
    HostListener
  } from '@angular/core';
  import { NgControl } from '@angular/forms';
  
  @Directive({
    selector: '[appIndianNumberFormat]'
  })
  export class IndianNumberFormatDirective implements DoCheck {
  
    private lastValue = '';
  
    constructor(
      private el: ElementRef<HTMLInputElement>,
      private control: NgControl
    ) {}
  
    // Detect API / ngModel / patchValue changes
    ngDoCheck(): void {
      const value = this.control?.control?.value;
  
      if (value == null || value === '') {
        this.lastValue = '';
        this.el.nativeElement.value = '';
        return;
      }
  
      const raw = String(value).replace(/,/g, '');
  
      if (raw !== this.lastValue) {
        this.lastValue = raw;
        this.el.nativeElement.value = this.format(raw);
      }
    }
  
    @HostListener('focus')
    onFocus(): void {
      this.el.nativeElement.value = this.lastValue;
    }
  
    @HostListener('blur')
    onBlur(): void {
      this.el.nativeElement.value = this.format(this.lastValue);
    }
  
    @HostListener('input', ['$event'])
    onInput(event: Event): void {
  
      const input = event.target as HTMLInputElement;
  
      let raw = input.value.replace(/,/g, '');
  
      // Allow only numbers
      raw = raw.replace(/[^\d]/g, '');
  
      this.lastValue = raw;
  
      // Update ngModel/FormControl
      this.control.control?.setValue(raw, {
        emitEvent: false
      });
  
      // Show formatted value
      input.value = this.format(raw);
    }
  
    private format(value: string): string {
  
      if (!value) {
        return '';
      }
  
      return Number(value).toLocaleString('en-IN');
    }
  }